import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Recogida',
  [OrderMethod.Delivery]: 'Entrega',
  [OrderMethod.OnSite]: 'En el local',
};
